import { reportWebVitals } from '@telemetry';

void import('@app').then(async ({ appBootstrap }) => {
  await appBootstrap();
});

reportWebVitals();
